<section class="loginPage">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="loginPanel">
                    <div class="logo">
                        <img src="../../assets/img/logo.png" alt="Medicinae">
                    </div>
                    <div class="actions">
                        <!-- Nav tabs -->
                        <ul class="nav nav-tabs" role="tablist">
                            <li role="presentation" class="active"><a href="#login" aria-controls="login" role="tab" data-toggle="tab">Login</a></li>
                        </ul>

                        <!-- Tab panes -->
                        <div class="tab-content">
                            <div role="tabpanel" class="tab-pane active" id="login">
                                <form [formGroup]="form" (ngSubmit)="onSubmit(form.value)" class="form-horizontal">
                                    <div class="input-group">
                                        <input type="text" class="form-control" name="email" placeholder="Digite seu e-mail" aria-describedby="basic-addon1" formControlName="email">
                                        <span class="input-group-addon" id="basic-addon1"><i class="fa fa-envelope" aria-hidden="true"></i></span>
                                    </div>
                                    <div *ngIf="formErrors.email" class="alert-danger error-msg black">
                                        {{ formErrors.email }}
                                    </div>
                                    <div class="input-group">
                                        <input type="password" class="form-control" name="password" placeholder="Digite sua senha" aria-describedby="basic-addon1"
                                            formControlName="password">
                                        <span class="input-group-addon" id="basic-addon1"><i class="fa fa-unlock-alt" aria-hidden="true"></i></span>
                                    </div>
                                    <div *ngIf="formErrors.password" class="alert-danger error-msg black">
                                        {{ formErrors.password }}
                                    </div>
                                    <div class="form-group row">
                                        <div class="col-sm-12">
                                            <!-- <button [disabled]="!form.valid" type="submit" class="btn btn-default btn-auth">Entrar</button> -->
                                            <a routerLink="/forgot-password" class="forgot-pass">Esqueci minha senha</a>
                                            <!--<button type="submit" class="btn btn-default btn-auth">Entrar</button>-->
                                            <loading-button [is-visible]="showLoading" [is-user]="isUser" text="Entrar"></loading-button>
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <div class="col-sm-12">
                                            <div class="alert alert-danger" *ngFor="let err of errors">
                                                {{ err }}
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
